<template>
  <div class="" id="search">
    <div class="row">
      <div class="col">
        <nav class="navbar">
          <div class="container">
            <a class="navbar-brand text-info" href="/anasayfa">
              <h1>friendsquads</h1>
            </a>
            <form class="d-flex">
              <router-link to="giris">
                <button class="btn btn-outline-info mx-1">Oturum Aç</button>
              </router-link>
              <router-link to="kayit">
                <button class="btn btn-info mx-1">Kayıt Ol</button></router-link
              >
            </form>
          </div>
        </nav>
      </div>
    </div>
    <div class="row" style="height: 80vh">
      <div class="col my-auto">
        <div class="input-group w-50 mx-auto">
          <input
            type="text"
            class="form-control form-control-lg"
            placeholder="Ürün / Hizmet Ara"
          />
          <button class="btn btn-info" type="button">
            <i class="fas fa-search text-white"></i>
          </button>
        </div>
        <!-- <h3 class="text-center mx-auto my-4">
          TEK TIKLA BİNLERCE YORUMA ULAŞIN
        </h3> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
#search {
  background-image: url(../assets/pexels-nick-demou-1250282.jpg);
  background-position: center;
  background-size: 100%;
  height: 98vh;
}
</style>
